import { INITIATE_CASE_STATE } from "constants";

import {
    fetchUser,
    fetchedUser,
    failedFetchUser,
    fetchUserPermissions,
    fetchedUserPermissions,
    failedFetchUserPermissions
} from "./user-actions";
import {
    authenticateUser,
    authenticatedUser,
    failedAuthenticateUser,
    logout
} from "./auth-actions";

import {
    fetchCases,
    fetchedCases,
    failedFetchCases,
    fetchMoreCases,
    fetchedMoreCases,
    failedFetchMoreCases,
    fetchCasesCount,
    fetchedCasesCount,
    failedFetchCasesCount,
    downloadCasesXlsx
} from "./case-actions";

import {
    fetchBucketCases,
    fetchedBucketCases,
    failedFetchBucketCases,
    assignBucketCases,
    assignedBucketCases,
    failedAssignBucketCases,
    proceedBucketCases,
    successProceedBucketCases,
    failedProceedBucketCases,
    referBucketCases,
    successReferBucketCases,
    failedReferBucketCases,
    bulkAssignBucketCases,
    bulkAssignedBucketCases,
    failedBulkAssignBucketCases
} from "./bucket-case-actions";

import {
    fetchCaseDetail,
    fetchedCaseDetail,
    failedFetchCaseDetail,
    updateCaseDetail,
    updatedCaseDetail,
    failedUpdateCaseDetail,
    fetchCaseDetailFields,
    fetchedCaseDetailFields,
    failedFetchCaseDetailFields,
    updateCaseDetailFields,
    updatedCaseDetailFields,
    failedUpdateCaseDetailFields,
    fetchChannelProductStats,
    fetchedChannelProductStats,
    failedFetchChannelProductsStats,
    updateChannelProductStats,
    updatedChannelProductStats,
    failedUpdateChannelProductsStats,
    updateCaseRemarks,
    updatedCaseRemarks,
    failedUpdateCaseRemarks,
    downloadApplicationForm,
    downloadedApplicationForm,
    failedDownloadApplicationForm,
    uploadCompanyLedger,
    uploadedCompanyLedger,
    failedUploadCompanyLedger,
    addNewChannelProduct,
    updateCaseQuestionnaire,
    updatedCaseQuestionnaire,
    failedUpdateCaseQuestionnaire,
    downloadCaseQuestionnaire,
    updateCaseType,
    updatedCaseType,
    failedUpdateCaseType,
    updateProcessingFee,
    fetchCaseAssociates,
    fetchedCaseAssociates,
    failedFetchCaseAssociates,
    addCaseAssociates,
    addedCaseAssociates,
    failedAddCaseAssociates,
    deleteCaseAssociates,
    deletedCaseAssociates,
    failedDeleteCaseAssociates,
    updateCaseAssociateStatus,
    addCaseCompanyAssociates,

    fetchCaseBankAccounts,
    fetchedCaseBankAccounts,
    failedFetchCaseBankAccounts,
    addCaseBankAccounts,
    addedCaseBankAccounts,
    failedAddCaseBankAccounts,
    deleteCaseBankAccounts,
    deletedCaseBankAccounts,
    failedDeleteCaseBankAccounts,
    fetchCaseDocumentChecklist,
    fetchedCaseDocumentChecklist,
    failedFetchCaseDocumentChecklist,

    fetchCaseRemarks,
    fetchedCaseRemarks,
    failedFetchCaseRemarks,

    GstinsearchList,
    fetchCaseEnachMandataDetails,
    fetchedCaseEnachMandataDetails,
    failedFetchCaseEnachMandataDetails,
    fetchCaseEnachMandateStatus,
    fetchedCaseEnachMandateStatus,
    failedFetchCaseEnachMandateStatus
} from "./case-details-actions";

import {
    fetchQuestionare,
    fetchedQuestionare,
    failedFetchQuestionare,
    fetchAnswers,
    fetchedAnswers,
    failedFetchAnswers,
    updateAnswersForQuestionare,
    updatedAnswersForQuestionare,
    failedUpdateAnswersForQuestionare
} from "./questionare-actions";
import {
    fetchDocumentsChecklist,
    fetchedDocumentsChecklist,
    failedFetchDocumentsChecklist,
    fetchCaseDocuments,
    fetchedCaseDocuments,
    failedFetchCaseDocuments,
    fetchCompanyDocuments,
    fetchedCompanyDocuments,
    failedFetchCompanyDocuments,
    uploadDocuments,
    uploadedDocuments,
    failedUploadDocument,
    uploadedDocument,
    uploadDocument,
    failedUploadDocuments,
    attachDocument,
    attachedDocument,
    failedAttachDocument,
    updateDocument,
    updatedDocument,
    failedUpdateDocument,
    validateDocument,
    validatedDocument,
    validatedDocumentApproval,
    failedValidateDocument,
    invalidateDocument,
    invalidatedDocumentStatus,
    invalidatedDocument,
    failedInvalidateDocumentStatus,
    failedInvalidateDocument,
    fetchDocumentTypes,
    fetchedDocumentTypes,
    failedFetchDocumentTypes,
    fetchApplicantsList,
    fetchedApplicantsList,
    failedFetchApplicantsList,
    parseDocument,
    parsedDocument,
    failedParseDocument,
    requestDocuments,
    requestedDocuments,
    failedRequestDocuments,
    sendRequest,
    notificationSent,
    failedToSendNotification,
    addedRequestRemarks,
    addRequestRemarks,
    failedAddRequestRemarks,
    fetchDocumentsCaseV2,
    fetchedDocumentsCaseV2,
    failedFetchDocumentsCaseV2
} from "./documents-actions";

import {
    fetchCamEngineView,
    fetchedCamEngineView,
    failedFetchCamEngineView,
    fetchCamEngineViewComments,
    fetchedCamEngineViewComments,
    failedFetchCamEngineViewComments,
    fetchBounceCharges,
    fetchPrePaymentCharges,
    fetchFee,
    fetchPortfolioView,
    fetchedPortfolioView,
    failedFetchPortfolioView,
    fetchCamEngineStatusLogs,
    fetchedCamEngineStatusLogs,
    failedFetchCamEngineStatusLogs
} from "../../modules/companies/actions";

import {
    fetchCompanyProfile,
    fetchedCompanyProfile,
    failedFetchCompanyProfile,
    updateCompanyProfile,
    updatedCompanyProfile,
    failedUpdateCompanyProfile,
    fetchCompanyAssociates,
    fetchedCompanyAssociates,
    failedFetchCompanyAssociates,
    updateCompanyAssociates,
    updatedCompanyAssociates,
    failedUpdateCompanyAssociates,
    updateCompanyAssociatesCibil,
    updatedCompanyAssociatesCibil,
    failedUpdateCompanyAssociatesCibil,
    fetchCompanyAddresses,
    fetchedCompanyAddresses,
    failedFetchCompanyAddresses,
    updateCompanyAddresses,
    updatedCompanyAddresses,
    failedUpdateCompanyAddresses,
    updateCompanyAddress,
    updatedCompanyAddress,
    failedUpdateCompanyAddress,
    fetchCompanyBankAccounts,
    fetchedCompanyBankAccounts,
    failedFetchCompanyBankAccounts,
    updateCompanyBankAccounts,
    updatedCompanyBankAccounts,
    failedUpdateCompanyBankAccounts,
    updateCompanySingleAssociate,
    updatedCompanySingleAssociate,
    failedUpdateCompanySingleAssociate,
    updateCompanyMultipleAssociate,
    updatedCompanyMultipleAssociate,
    failedUpdateCompanyMultipleAssociate,
    updateCompanySingleAddress,
    updatedCompanySingleAddress,
    failedUpdateCompanySingleAddress,
    fetchCompanyGstinFillingDetails,
    fetchedCompanyGstinFillingDetails,
    failedFetchCompanyGstinFillingDetails,
    refreshCompanyGstinFillingDetails,
    refreshedCompanyGstinFillingDetails,
    failedRefreshCompanyGstinFillingDetails,
    updateCompanySingleBankAccount,
    updatedCompanySingleBankAccount,
    failedUpdateCompanySingleBankAccount,

    fetchCompanyChecklist,
    fetchedCompanyChecklist,
    failedFetchCompanyChecklist,

    fetchCompanyNotes,
    fetchedCompanyNotes,
    failedFetchCompanyNotes,

    createCompanyNotes,
    fetchedCreateCompanyNotes,
    failedCreateCompanyNotes,

    fetchCompanyAssociatesV2,
    fetchedCompanyAssociatesV2,
    failedFetchCompanyAssociatesV2,

    updateMpaDetails,
    updatedMpaDetails,
    failedUpdateMpaDetails,

    fetchCompanyAllMpa,
    fetchedCompanyAllMpa,
    failedFetchCompanyAllMpa,
    clearCompanyAllMpa,

    fetchEnums,
    fetchedEnums,
    failedFetchEnums,

    fetchPanAadharLink,
    fetchedPanAadharLink,
    failedFetchPanAadharLink
} from "./company-actions";

import {
    fetchStageCase,
    fetchedStageCase,
    failedFetchStageCase,
    fetchedStageCaseCount,
    resetStageCase
} from "./stage-case-actions";

import {
    fetchStagesList,
    fetchedStagesList,
    failedFetchStagesList
} from "./stage-actions";

import {
    approveCase,
    approvedCase,
    failedApproveCase,
    proceedCase,
    proceedCaseSucceed,
    proceedCaseFailed,
    rejectCase,
    rejectCaseSucceed,
    rejectCaseFailed,
    referCase,
    referCaseSucceed,
    referCaseFailed,
    assignCase,
    assignCaseSucceed,
    assignCaseFailed,
    reassignCase,
    reassignCaseSucceed,
    reassignCaseFailed,
    openHoldCase,
    openHoldCaseSucceed,
    openHoldCaseFailed,
    holdCase,
    holdCaseSucceed,
    holdCaseFailed
} from "./update-case-actions";

import {
    fetchCaseSupplyChainDetails,
    fetchedCaseSupplyChainDetails,
    failedFetchCaseSupplyChainDetails,
    updateCaseSupplyChainDetails,
    updatedCaseSupplyChainDetails,
    failedUpdateCaseSupplyChainDetails,
    fetchCaseSupplyChainFinancials,
    fetchedCaseSupplyChainFinancials,
    failedFetchCaseSupplyChainFinancials
} from "./supply-chain-actions";

import {
    createStatement,
    createdStatement,
    deleteStatement,
    deletedStatement,
    failedDeleteStatement,
    fetchStatement,
    fetchedStatement,
    failedFetchStatement,
    updateStatement,
    updatedStatement,
    failedUpdateStatement
} from "./statement-actions";

import {
    fetchScoreCard,
    fetchedScoreCard,
    failedFetchScoreCard,
    generateScoreCard,
    generatedScoreCard,
    failedGenerateScoreCard
} from "./scorecard-actions";

import {
    addCaseEntry,
    removeCaseEntry,
    openCase,
    successOpenCase,
    failedOpenCase,
    createCase,
    createdCase,
    failedCreateCase,
    resetCaseCreate,
    createBulkAdhocCase,
    createdBulkAdhocCase,
    failedCreateBulkAdhocCase,
    createBulkPayProCase,
    createdBulkPayProCase,
    failedCreateBulkPayProCase
} from "./case-create-actions";

import {
    createFinancialYear,
    createdFinancialYear,
    failedCreateFinancialYear,
    fetchFinancialYears,
    fetchedFinancialYears,
    failedFetchFinancialYears,
    fetchFinancials,
    fetchedFinancials,
    failedFetchFinancials,
    updateFinancials,
    updatedFinancials,
    failedUpdateFinancials
} from "./financials-actions";

import {
    createCaseNote,
    createdCaseNote,
    failedCreateCaseNote,
    fetchCaseNotes,
    fetchedCaseNotes,
    failedFetchCaseNotes,
    deleteCaseNote,
    deletedCaseNote,
    failedDeleteCaseNote,
    retrieveCaseNote,
    retrievedCaseNote,
    failedRetrieveCaseNote
} from "./case-note-actions";

import {
    fetchPayProCaseNotes,
    fetchedPayProCaseNotes,
    failedFetchPayProCaseNotes,
} from "./paypro-case-note-actions";

import {
    fetchAccountSummary,
    fetchedAccountSummary,
    failedFetchAccountSummary,
    fetchAccountStatement,
    fetchedAccountStatement,
    failedFetchAccountStatement,
    fetchFacilityAccountOpenInvoices,
    fetchedFacilityAccountOpenInvoices,
    failedFetchAccountOpenInvoices
} from "./account-view-actions";

import {
    fetchBusinessProductList,
    fetchedBusinessProductList,
    failedFetchBusinessProductList,
    fetchBusinessProgramList,
    fetchedBusinessProgramList,
    failedFetchBusinessProgramList,
    fetchBusinessProgramDetail,
    fetchedBusinessProgramDetail,
    failedFetchBusinessProgramDetail,
    fetchCompanyBusinessProgramDetail,
    fetchedCompanyBusinessProgramDetail,
    failedFetchCompanyBusinessProgramDetail,
    createBusinessProgram,
    createdBusinessProgram,
    failedCreateBusinessProgram,
    updateBusinessProgram,
    updatedBusinessProgram,
    failedUpdateBusinessProgram,
    createBuyerQualificationDetails,
    createdBuyerQualificationDetails,
    failedCreateBuyerQualificationDetails,
    updateBuyerQualificationDetails,
    updatedBuyerQualificationDetails,
    failedUpdateBuyerQualificationDetails,
    createBusinessProgramInterest,
    createdBusinessProgramInterest,
    failedCreateBusinessProgramInterest,
    updateBusinessProgramInterest,
    updatedBusinessProgramInterest,
    failedUpdateBusinessProgramInterest,
    createBusinessProgramFee,
    createdBusinessProgramFee,
    failedCreateBusinessProgramFee,
    updateBusinessProgramFee,
    updatedBusinessProgramFee,
    failedUpdateBusinessProgramFee,
    createBusinessProgramFacilityDetails,
    createdBusinessProgramFacilityDetails,
    failedCreateBusinessProgramFacilityDetails,
    updateBusinessProgramFacilityDetails,
    updatedBusinessProgramFacilityDetails,
    failedUpdateBusinessProgramFacilityDetails,
    createBusinessProgramRecourseDetails,
    createdBusinessProgramRecourseDetails,
    failedCreateBusinessProgramRecourseDetails,
    updateBusinessProgramRecourseDetails,
    updatedBusinessProgramRecourseDetails,
    failedUpdateBusinessProgramRecourseDetails,
    createBusinessProgramCashBack,
    createdBusinessProgramCashBack,
    failedCreateBusinessProgramCashBack,
    updateBusinessProgramCashBack,
    updatedBusinessProgramCashBack,
    failedUpdateBusinessProgramCashBack,
    createBusinessAttachments,
    createdBusinessAttachments,
    failedCreateBusinessAttachments,
    updateBusinessAttachments,
    updatedBusinessAttachments,
    failedUpdateBusinessAttachments,
    createBasicDetails,
    createdBasicDetails,
    failedCreateBasicDetails,
    updateBasicDetails,
    updatedBasicDetails,
    failedUpdateBasicDetails,
    createBusinessAgreementDetails,
    createdBusinessAgreementDetails,
    failedCreateBusinessAgreementDetails,
    updateBusinessAgreementDetails,
    updatedBusinessAgreementDetails,
    failedUpdateBusinessAgreementDetails
} from "./mpa-actions";

import {
    fetchNewDocumentsList,
    fetchedNewDocumentsList,
    failedFetchNewDocumentsList,
    fetchNewDocumentsCategoryList,
    fetchedNewDocumentsCategoryList,
    failedFetchNewDocumentsCategoryList,
    fetchNewDocumentsChecklist,
    fetchedNewDocumentsChecklist,
    failedFetchNewDocumentsChecklist,
    fetchSingleChecklist,
    fetchedSingleChecklist,
    failedFetchSingleChecklist,
    updateChecklist,
    updatedChecklist,
    failedUpdateChecklist,
    createChecklist,
    createdChecklist,
    failedCreateChecklist
} from "./documents-new-actions";

import { toggleHelp } from "./toggle-help-actions";

import {
    fetchMarketData,
    fetchedMarketData,
    failedCreateMarketData,
    createMarketData,
    createdMarketData,
    failedFetchMarketData,
    updateMarketData,
    updatedMarketData,
    failedUpdateMarketData
} from "./market-data-actions";

import {
    fetchRegionList,
    fetchedRegionList,
    failedFetchRegionList,
    fetchRegionWiseList,
    fetchedRegionWiseList,
    failedFetchRegionWiseList,
    createRegion,
    createdRegion,
    failedCreateRegion
} from "./region-distributors-action";

import {
    resetCaseMeta,
    updateCaseMeta,
    updatedCaseMeta,
    failedUpdateCaseMeta
} from "./case-meta-actions";

import {
    createFacilityAccount,
    createdFacilityAccount,
    failedCreateFacilityAccounts,
    fetchFacilityAccount,
    fetchedFacilityAccount,
    failedFetchFacilityAccounts,
    fetchFacilityAccountSupplyChains,
    fetchedFacilityAccountSupplyChains,
    failedFetchFacilityAccountSupplyChains,
    updateFacilityAccountSupplyChains,
    updatedFacilityAccountSupplyChains,
    failedUpdateFacilityAccountSupplyChains
} from "./facility-account-actions";

import {
    createRequest,
    createProfiosRequest,
    createdRequest,
    failedCreateRequest,
    fetchJobsList,
    fetchedJobsList,
    failedFetchJobsList,
    fetchJobsDetails,
    fetchJobsDetailsPerfios,
    fetchedJobsDetails,
    failedFetchJobsDetails,
    fetchStatementAnalysis,
    fetchStatementAnalysisPerfois,
    fetchedStatementAnalysis,
    failedFetchStatementAnalysis,
    retryAnalysis,
    retryAnalysisPerfios,
    retryAnalysisSucceed,
    retryAnalysisFailed,
} from "./bank-statement-analyser-actions";

import {
    fetchAssociatesVerificationList,
    fetchedAssociatesVerificationList,
    failedFetchAssociatesVerificationList,
} from "./applicant-verification-actions";

import {
    fetchCibilDetails,
    fetchedCibilDetails,
    failedFetchCibilDetails,
    updateCibilDetails,
    updatedCibilDetails,
    failedUpdateCibilDetails,
    createCibilRequest,
    createdCibilRequest,
    failedCreateCibilRequest
} from "./cibil-actions";

import {
    fetchPaymentProgramDetails,
    fetchedPaymentProgramDetails,
    failedFetchPaymentProgramDetails,
    updateUserDocumentDetails,
    updatedUserDocumentDetails,
    failedUpdateUserDocumentDetails,
    fetchUpdateChecklistJson,
    fetchUpdatedChecklistJson,
    failedFetchUpdateChecklistJson,
    fetchUpdateEntityDocuments,
    fetchedUpdateEntityDocuments,
    failedUpdateEntityDocuments,
    fetchPaymentProgramActionDetails,
    fetchedPaymentProgramActionDetails,
    failedFetchPaymentProgramActionDetails
} from "./payment-program-actions";

import {
    fetchDBOnBoardingList,
    fetchedDBOnBoardingList,
    failedFetchDBOnBoardingList
} from './db-onboarding-actions';

import {
    fetchCasesList,
    fetchedCasesList,
    failedFetchCasesList,

    clearWorkflowCaseDetail,
    fetchWorkflowCaseDetail,
    fetchedWorkflowCaseDetail,
    failedFetchWorkflowCaseDetai,
    
    fetchCasePendencyDetail,
    fetchedCasePendencyDetail,
    failedFetchCasePendencyDetail,
    
    fetchCompanyBackground,
    fetchedCompanyBackground,
    failedFetchCompanyBackground,
    
    fetchDeviationMatrix,
    fetchedDeviationMatrix,
    failedFetchDeviationMatrix,

} from './onboarding-actions'

import {
    fetchRetailerRiskControlDetail,
    fetchedRetailerRiskControlDetail,
    failedFetchRetailerRiskControlDetail,
    updateRetailerRiskControlDetail,
    updatedRetailerRiskControlDetail,
    failedUpdateRetailerRiskControlDetail
} from './retailer-risk-control-actions'

export function initiateCaseState(case_id) {
    return {
        type: INITIATE_CASE_STATE,
        payload: {
            case_id
        }
    };
}



export {
    fetchedUser,
    fetchUser,
    failedFetchUser,
    authenticateUser,
    authenticatedUser,
    failedAuthenticateUser,
    logout,
    fetchUserPermissions,
    fetchedUserPermissions,
    failedFetchUserPermissions,
    fetchCases,
    fetchedCases,
    failedFetchCases,
    fetchMoreCases,
    fetchedMoreCases,
    failedFetchMoreCases,
    fetchStageCase,
    fetchedStageCase,
    failedFetchStageCase,
    fetchedStageCaseCount,
    resetStageCase,
    fetchCaseDetail,
    fetchedCaseDetail,
    updateCaseDetail,
    updatedCaseDetail,
    failedUpdateCaseDetail,
    fetchCaseDetailFields,
    fetchedCaseDetailFields,
    failedFetchCaseDetailFields,
    updateCaseDetailFields,
    updatedCaseDetailFields,
    failedUpdateCaseDetailFields,
    updateCaseRemarks,
    updatedCaseRemarks,
    failedUpdateCaseRemarks,
    failedFetchCaseDetail,
    fetchCasesCount,
    fetchedCasesCount,
    failedFetchCasesCount,
    fetchStagesList,
    fetchedStagesList,
    failedFetchStagesList,
    approveCase,
    approvedCase,
    failedApproveCase,
    proceedCase,
    proceedCaseSucceed,
    proceedCaseFailed,
    rejectCase,
    rejectCaseSucceed,
    rejectCaseFailed,
    openHoldCase,
    openHoldCaseSucceed,
    openHoldCaseFailed,
    holdCase,
    holdCaseSucceed,
    holdCaseFailed,
    referCase,
    referCaseSucceed,
    referCaseFailed,
    assignCase,
    assignCaseSucceed,
    addedRequestRemarks,
    addRequestRemarks,
    failedAddRequestRemarks,
    fetchDocumentsCaseV2,
    fetchedDocumentsCaseV2,
    failedFetchDocumentsCaseV2,
    assignCaseFailed,
    reassignCase,
    reassignCaseSucceed,
    reassignCaseFailed,
    fetchCaseSupplyChainDetails,
    fetchedCaseSupplyChainDetails,
    failedFetchCaseSupplyChainDetails,
    fetchCaseSupplyChainFinancials,
    fetchedCaseSupplyChainFinancials,
    failedFetchCaseSupplyChainFinancials,
    updateCaseSupplyChainDetails,
    updatedCaseSupplyChainDetails,
    failedUpdateCaseSupplyChainDetails,
    downloadApplicationForm,
    downloadedApplicationForm,
    failedDownloadApplicationForm,
    updateCaseType,
    updatedCaseType,
    failedUpdateCaseType,
    fetchCaseAssociates,
    fetchedCaseAssociates,
    failedFetchCaseAssociates,
    addCaseAssociates,
    addedCaseAssociates,
    failedAddCaseAssociates,
    deleteCaseAssociates,
    deletedCaseAssociates,
    failedDeleteCaseAssociates,
    updateCaseAssociateStatus,
    addCaseCompanyAssociates,
    //Update Company Associates
    fetchCompanyProfile,
    fetchedCompanyProfile,
    failedFetchCompanyProfile,
    updateCompanyProfile,
    updatedCompanyProfile,
    failedUpdateCompanyProfile,
    fetchCompanyAssociates,
    fetchedCompanyAssociates,
    failedFetchCompanyAssociates,
    updateCompanyAssociates,
    updatedCompanyAssociates,
    failedUpdateCompanyAssociates,
    updateCompanyAssociatesCibil,
    updatedCompanyAssociatesCibil,
    failedUpdateCompanyAssociatesCibil,
    fetchCompanyAddresses,
    fetchedCompanyAddresses,
    failedFetchCompanyAddresses,
    updateCompanyAddresses,
    updatedCompanyAddresses,
    failedUpdateCompanyAddresses,
    updateCompanyAddress,
    updatedCompanyAddress,
    failedUpdateCompanyAddress,
    fetchCompanyBankAccounts,
    fetchedCompanyBankAccounts,
    failedFetchCompanyBankAccounts,
    updateCompanyBankAccounts,
    updatedCompanyBankAccounts,
    failedUpdateCompanyBankAccounts,
    uploadCompanyLedger,
    uploadedCompanyLedger,
    failedUploadCompanyLedger,
    fetchDocumentTypes,
    fetchedDocumentTypes,
    failedFetchDocumentTypes,
    fetchApplicantsList,
    fetchedApplicantsList,
    failedFetchApplicantsList,
    parseDocument,
    parsedDocument,
    failedParseDocument,
    updateCompanySingleAssociate,
    updatedCompanySingleAssociate,
    failedUpdateCompanySingleAssociate,
    updateCompanyMultipleAssociate,
    updatedCompanyMultipleAssociate,
    failedUpdateCompanyMultipleAssociate,
    updateCompanySingleAddress,
    sendRequest,
    updatedCompanySingleAddress,
    failedUpdateCompanySingleAddress,
    updateCompanySingleBankAccount,
    updatedCompanySingleBankAccount,
    failedUpdateCompanySingleBankAccount,
    // Questionare
    fetchQuestionare,
    fetchedQuestionare,
    failedFetchQuestionare,
    fetchAnswers,
    fetchedAnswers,
    failedFetchAnswers,
    updateAnswersForQuestionare,
    updatedAnswersForQuestionare,
    failedUpdateAnswersForQuestionare,
    updateCaseQuestionnaire,
    updatedCaseQuestionnaire,
    failedUpdateCaseQuestionnaire,
    downloadCaseQuestionnaire,
    //Documents Actions
    fetchDocumentsChecklist,
    fetchedDocumentsChecklist,
    failedFetchDocumentsChecklist,
    fetchCaseDocuments,
    fetchedCaseDocuments,
    failedFetchCaseDocuments,
    fetchCompanyDocuments,
    fetchedCompanyDocuments,
    failedFetchCompanyDocuments,
    uploadDocuments,
    uploadedDocuments,
    failedUploadDocuments,
    failedUploadDocument,
    uploadedDocument,
    uploadDocument,
    attachDocument,
    attachedDocument,
    failedAttachDocument,
    updateDocument,
    updatedDocument,
    failedUpdateDocument,
    validateDocument,
    validatedDocument,
    validatedDocumentApproval,
    failedValidateDocument,
    invalidateDocument,
    invalidatedDocument,
    invalidatedDocumentStatus,
    failedInvalidateDocumentStatus,
    failedInvalidateDocument,
    requestDocuments,
    requestedDocuments,
    failedRequestDocuments,
    notificationSent,
    failedToSendNotification,
    //Statement Actions
    createStatement,
    createdStatement,
    fetchStatement,
    fetchedStatement,
    failedFetchStatement,
    updateStatement,
    updatedStatement,
    failedUpdateStatement,
    deleteStatement,
    deletedStatement,
    failedDeleteStatement,
    //Generate Score Card
    fetchScoreCard,
    fetchedScoreCard,
    failedFetchScoreCard,
    generateScoreCard,
    generatedScoreCard,
    failedGenerateScoreCard,
    //New Case
    openCase,
    successOpenCase,
    failedOpenCase,
    addCaseEntry,
    removeCaseEntry,
    createCase,
    createdCase,
    failedCreateCase,
    resetCaseCreate,
    createBulkAdhocCase,
    createdBulkAdhocCase,
    failedCreateBulkAdhocCase,
    createBulkPayProCase,
    createdBulkPayProCase,
    failedCreateBulkPayProCase,
    //Case Meta Actions
    resetCaseMeta,
    updateCaseMeta,
    updatedCaseMeta,
    failedUpdateCaseMeta,
    //Case Notes
    createCaseNote,
    createdCaseNote,
    failedCreateCaseNote,
    fetchCaseNotes,
    fetchedCaseNotes,
    failedFetchCaseNotes,
    //Company Financials
    createFinancialYear,
    createdFinancialYear,
    failedCreateFinancialYear,
    fetchFinancialYears,
    fetchedFinancialYears,
    failedFetchFinancialYears,
    fetchFinancials,
    fetchedFinancials,
    failedFetchFinancials,
    updateFinancials,
    updatedFinancials,
    failedUpdateFinancials,
    updateProcessingFee,
    // bucket-list actions
    fetchBucketCases,
    fetchedBucketCases,
    failedFetchBucketCases,
    assignBucketCases,
    assignedBucketCases,
    failedAssignBucketCases,
    proceedBucketCases,
    successProceedBucketCases,
    failedProceedBucketCases,
    referBucketCases,
    successReferBucketCases,
    failedReferBucketCases,
    bulkAssignBucketCases,
    bulkAssignedBucketCases,
    failedBulkAssignBucketCases,
    // Company Top brands
    fetchChannelProductStats,
    fetchedChannelProductStats,
    failedFetchChannelProductsStats,
    updateChannelProductStats,
    updatedChannelProductStats,
    failedUpdateChannelProductsStats,
    // MPA, DPA Actions
    fetchBusinessProductList,
    fetchedBusinessProductList,
    failedFetchBusinessProductList,
    fetchBusinessProgramList,
    fetchedBusinessProgramList,
    failedFetchBusinessProgramList,
    fetchBusinessProgramDetail,
    fetchedBusinessProgramDetail,
    failedFetchBusinessProgramDetail,
    createBusinessProgram,
    createdBusinessProgram,
    failedCreateBusinessProgram,
    updateBusinessProgram,
    updatedBusinessProgram,
    failedUpdateBusinessProgram,
    createBuyerQualificationDetails,
    createdBuyerQualificationDetails,
    failedCreateBuyerQualificationDetails,
    updateBuyerQualificationDetails,
    updatedBuyerQualificationDetails,
    failedUpdateBuyerQualificationDetails,
    createBusinessProgramInterest,
    createdBusinessProgramInterest,
    failedCreateBusinessProgramInterest,
    updateBusinessProgramInterest,
    updatedBusinessProgramInterest,
    failedUpdateBusinessProgramInterest,
    createBusinessProgramFee,
    createdBusinessProgramFee,
    failedCreateBusinessProgramFee,
    updateBusinessProgramFee,
    updatedBusinessProgramFee,
    failedUpdateBusinessProgramFee,
    createBusinessProgramFacilityDetails,
    createdBusinessProgramFacilityDetails,
    failedCreateBusinessProgramFacilityDetails,
    updateBusinessProgramFacilityDetails,
    updatedBusinessProgramFacilityDetails,
    failedUpdateBusinessProgramFacilityDetails,
    createBusinessProgramRecourseDetails,
    createdBusinessProgramRecourseDetails,
    failedCreateBusinessProgramRecourseDetails,
    updateBusinessProgramRecourseDetails,
    updatedBusinessProgramRecourseDetails,
    failedUpdateBusinessProgramRecourseDetails,
    createBusinessProgramCashBack,
    createdBusinessProgramCashBack,
    failedCreateBusinessProgramCashBack,
    updateBusinessProgramCashBack,
    updatedBusinessProgramCashBack,
    failedUpdateBusinessProgramCashBack,
    createBusinessAttachments,
    createdBusinessAttachments,
    failedCreateBusinessAttachments,
    updateBusinessAttachments,
    updatedBusinessAttachments,
    failedUpdateBusinessAttachments,
    createBasicDetails,
    createdBasicDetails,
    failedCreateBasicDetails,
    updateBasicDetails,
    updatedBasicDetails,
    failedUpdateBasicDetails,
    createBusinessAgreementDetails,
    createdBusinessAgreementDetails,
    failedCreateBusinessAgreementDetails,
    updateBusinessAgreementDetails,
    updatedBusinessAgreementDetails,
    failedUpdateBusinessAgreementDetails,
    fetchCompanyBusinessProgramDetail,
    fetchedCompanyBusinessProgramDetail,
    failedFetchCompanyBusinessProgramDetail,
    // New Documents Actions
    fetchNewDocumentsList,
    fetchedNewDocumentsList,
    failedFetchNewDocumentsList,
    fetchNewDocumentsCategoryList,
    fetchedNewDocumentsCategoryList,
    failedFetchNewDocumentsCategoryList,
    fetchNewDocumentsChecklist,
    fetchedNewDocumentsChecklist,
    failedFetchNewDocumentsChecklist,
    fetchSingleChecklist,
    fetchedSingleChecklist,
    failedFetchSingleChecklist,
    updateChecklist,
    updatedChecklist,
    failedUpdateChecklist,
    createChecklist,
    createdChecklist,
    failedCreateChecklist,
    //toggleHelp
    toggleHelp,
    // Market Data Actions
    fetchMarketData,
    fetchedMarketData,
    failedCreateMarketData,
    createMarketData,
    createdMarketData,
    failedFetchMarketData,
    updateMarketData,
    updatedMarketData,
    failedUpdateMarketData,
    // Region Data
    fetchRegionList,
    fetchedRegionList,
    failedFetchRegionList,
    fetchRegionWiseList,
    fetchedRegionWiseList,
    failedFetchRegionWiseList,
    createRegion,
    createdRegion,
    failedCreateRegion,
    // Facility Accounts
    createFacilityAccount,
    createdFacilityAccount,
    failedCreateFacilityAccounts,
    fetchFacilityAccount,
    fetchedFacilityAccount,
    failedFetchFacilityAccounts,
    fetchFacilityAccountSupplyChains,
    fetchedFacilityAccountSupplyChains,
    failedFetchFacilityAccountSupplyChains,
    updateFacilityAccountSupplyChains,
    updatedFacilityAccountSupplyChains,
    failedUpdateFacilityAccountSupplyChains,
    // Account View Actions
    fetchAccountSummary,
    fetchedAccountSummary,
    failedFetchAccountSummary,
    fetchAccountStatement,
    fetchedAccountStatement,
    failedFetchAccountStatement,
    addNewChannelProduct,
    fetchFacilityAccountOpenInvoices,
    fetchedFacilityAccountOpenInvoices,
    failedFetchAccountOpenInvoices,
    // Case Actions
    downloadCasesXlsx,
    // Company Actions 
    fetchCompanyGstinFillingDetails,
    fetchedCompanyGstinFillingDetails,
    failedFetchCompanyGstinFillingDetails,
    refreshCompanyGstinFillingDetails,
    refreshedCompanyGstinFillingDetails,
    failedRefreshCompanyGstinFillingDetails,
    // Bank Statement Analyser
    createRequest,
    createProfiosRequest,
    createdRequest,
    failedCreateRequest,
    fetchJobsList,
    fetchedJobsList,
    failedFetchJobsList,
    fetchJobsDetails,
    fetchJobsDetailsPerfios,
    fetchedJobsDetails,
    failedFetchJobsDetails,
    fetchStatementAnalysis,
    fetchStatementAnalysisPerfois,
    fetchedStatementAnalysis,
    failedFetchStatementAnalysis,
    retryAnalysis,
    retryAnalysisPerfios,
    retryAnalysisSucceed,
    retryAnalysisFailed,
    fetchAssociatesVerificationList,
    fetchedAssociatesVerificationList,
    failedFetchAssociatesVerificationList,
    fetchCaseBankAccounts,
    fetchedCaseBankAccounts,
    failedFetchCaseBankAccounts,
    addCaseBankAccounts,
    addedCaseBankAccounts,
    failedAddCaseBankAccounts,
    deleteCaseBankAccounts,
    deletedCaseBankAccounts,
    failedDeleteCaseBankAccounts,
    deleteCaseNote,
    deletedCaseNote,
    failedDeleteCaseNote,
    retrieveCaseNote,
    retrievedCaseNote,
    failedRetrieveCaseNote,
    fetchCibilDetails,
    fetchedCibilDetails,
    failedFetchCibilDetails,
    updateCibilDetails,
    updatedCibilDetails,
    failedUpdateCibilDetails,
    createCibilRequest,
    createdCibilRequest,
    failedCreateCibilRequest,
    //Payment program
    fetchPaymentProgramDetails,
    fetchedPaymentProgramDetails,
    failedFetchPaymentProgramDetails,
    fetchCaseDocumentChecklist,
    fetchedCaseDocumentChecklist,
    failedFetchCaseDocumentChecklist,
    fetchPayProCaseNotes,
    fetchedPayProCaseNotes,
    failedFetchPayProCaseNotes,
    
    updateUserDocumentDetails,
    updatedUserDocumentDetails,
    failedUpdateUserDocumentDetails,
    fetchUpdateChecklistJson,
    fetchUpdatedChecklistJson,
    failedFetchUpdateChecklistJson,

    fetchUpdateEntityDocuments,
    fetchedUpdateEntityDocuments,
    failedUpdateEntityDocuments,

    fetchPaymentProgramActionDetails,
    fetchedPaymentProgramActionDetails,
    failedFetchPaymentProgramActionDetails,

    GstinsearchList,
    //Enach API's
    fetchCaseEnachMandataDetails,
    fetchedCaseEnachMandataDetails,
    failedFetchCaseEnachMandataDetails,
    fetchCaseEnachMandateStatus,
    fetchedCaseEnachMandateStatus,
    failedFetchCaseEnachMandateStatus,

    //DB Onboarding
    fetchDBOnBoardingList,
    fetchedDBOnBoardingList,
    failedFetchDBOnBoardingList,

    fetchCasePendencyDetail,
    fetchedCasePendencyDetail,
    failedFetchCasePendencyDetail,

    //Company Checklist 
    fetchCompanyChecklist,
    fetchedCompanyChecklist,
    failedFetchCompanyChecklist,

    updateMpaDetails,
    updatedMpaDetails,
    failedUpdateMpaDetails,

    //company notes
    fetchCompanyNotes,
    fetchedCompanyNotes,
    failedFetchCompanyNotes,

    //create company note
    createCompanyNotes,
    fetchedCreateCompanyNotes,
    failedCreateCompanyNotes,

    //Company Associates Fetch V2
    fetchCompanyAssociatesV2,
    fetchedCompanyAssociatesV2,
    failedFetchCompanyAssociatesV2,

    //Cam Engine Automation
    fetchCamEngineView,
    fetchedCamEngineView,
    failedFetchCamEngineView,

    //Cam Engine View Comments
    fetchCamEngineViewComments,
    fetchedCamEngineViewComments,
    failedFetchCamEngineViewComments,

    //Cam Engine Status Logs
    fetchCamEngineStatusLogs,
    fetchedCamEngineStatusLogs,
    failedFetchCamEngineStatusLogs,

    // Portfolio View
    fetchPortfolioView,
    fetchedPortfolioView,
    failedFetchPortfolioView,

    //Onboarding actions
    fetchCasesList,
    fetchedCasesList,
    failedFetchCasesList,

    clearWorkflowCaseDetail,
    fetchWorkflowCaseDetail,
    fetchedWorkflowCaseDetail,
    failedFetchWorkflowCaseDetai,

    fetchCompanyBackground,
    fetchedCompanyBackground,
    failedFetchCompanyBackground,

    fetchDeviationMatrix,
    fetchedDeviationMatrix,
    failedFetchDeviationMatrix,

    fetchCompanyAllMpa,
    fetchedCompanyAllMpa,
    failedFetchCompanyAllMpa,
    clearCompanyAllMpa,
    fetchEnums,
    fetchedEnums,
    failedFetchEnums,

    fetchBounceCharges,
    fetchPrePaymentCharges,
    fetchFee,

    fetchCaseRemarks,
    fetchedCaseRemarks,
    failedFetchCaseRemarks,

    fetchRetailerRiskControlDetail,
    fetchedRetailerRiskControlDetail,
    failedFetchRetailerRiskControlDetail,
    
    updateRetailerRiskControlDetail,
    updatedRetailerRiskControlDetail,
    failedUpdateRetailerRiskControlDetail,

    //Refresh Pan Aadhar link
    fetchPanAadharLink,
    fetchedPanAadharLink,
    failedFetchPanAadharLink,
};
